/**
 * Technical Specs Widget JS Handler Class.
 */
class TechnicalSpecsWidgetHandler extends elementorModules.frontend.handlers.SwiperBase {
	getDefaultSettings() {
		return {
			selectors: {
				carousel: '.technical-specs__columns',
				slideContent: '.swiper-slide',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings('selectors');

		const elements = {
			$swiperContainer: this.$element.find(selectors.carousel),
		};

		elements.$slides = elements.$swiperContainer.find(selectors.slideContent);

		return elements;
	}

	getSwiperSettings() {
		return {
			slidesPerView: 1,
			effect: 'slide',
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		};
	}

	async onInit(...args) {
		super.onInit(...args);

		if (!this.elements.$swiperContainer.length || 2 > this.elements.$slides.length) {
			return;
		}

		const Swiper = elementorFrontend.utils.swiper;
		this.swiper = await new Swiper(this.elements.$swiperContainer, this.getSwiperSettings());
		// Expose the swiper instance in the frontend
		this.elements.$swiperContainer.data('swiper', this.swiper);
	}
}

/**
 * Register JS Handler for the Video Masthead Widget
 */
elementorFrontend.elements.$window.on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler('technical-specs', TechnicalSpecsWidgetHandler);
});
